import { LICENSE_SGA, LICENSE_DGA } from '~/utils/license-utils';

import DGA from './DGA';
import SGA from './SGA';

type ConfigType = typeof SGA | typeof DGA;

const CONFIGS: { [key: string]: ConfigType } = {
	[LICENSE_SGA]: SGA,
	[LICENSE_DGA]: DGA
};

const configs = (license: string): ConfigType => CONFIGS[license] ?? CONFIGS[LICENSE_SGA];

export default configs;
